namespace TabAurous.Retail {

    /**
     * Our select editor with hardcoded values.
     * 
     * When you define a new editor type, make sure you build
     * and transform templates for it to be available 
     * in server side forms, e.g. [HardCodedValuesEditor]
     */
    @Serenity.Decorators.registerEditor()
    export class TempEditor extends Serenity.RadioButtonEditor {

        
        constructor(hidden: JQuery) {
            super(hidden, null);

            this.addRadio("101", "Jewellery");

            this.addRadio("104", "Metal");
            
            this.addRadio("105", "Stone");
        }
    }
}